import validate from 'validate.js'
import inView from 'in-view'
import { Scroll } from 'components/scroll'

export class FormValidationComponent {

  constructor(formElement, constraints) {
    this.constraints = constraints
    this.element = formElement
    this.formClass = "form-control"
    this.errorClass = `${this.formClass}--icon--error`
  }

  showErrorForInput(input, erro, isFirstElement) {
    const formControlEl = input.closest(`.${this.formClass}`);
    //const iconErroEl = formControlEl.querySelector('.error-icon');
    const msgErroEl = formControlEl.querySelector('.form-control__erro-pbm');

    this.clearErrors(input);

    if (input.id == 'consumidorCep')  {
      let ceps = document.getElementsByClassName('cep-pbm')
      for (let i=0; i < ceps.length; i++) {
        ceps[i].style.display = 'none'
      }
    }

    if(erro) {
        //formControlEl.appendChild(this.buildErrorIcon());
        formControlEl.appendChild(this.buildErrorMessage(erro));

      if(!formControlEl.classList.contains(this.errorClass))
        formControlEl.classList.add(this.errorClass);

    }

    if(isFirstElement && !inView.is(input)) {
      new Scroll(input, 300)
    }

  }

  clearErrors(input) {
    const formControlEl = input.closest(`.${this.formClass}`);

    formControlEl.classList.remove(this.errorClass);
    formControlEl.querySelectorAll('.form-control__erro-pbm').forEach((el) => {
      el.parentNode.removeChild(el);
    });
    /*
    formControlEl.querySelectorAll('.error-icon').forEach((el) => {
      el.parentNode.removeChild(el);
    });
    */
  }

  processErrors(errors) {
    if(!this.isFormValid(errors)){
      this.element.querySelectorAll('input, select, textarea').forEach((input, index) => {
        if(validate.contains(errors, input.name)) {
          this.showErrorForInput(input, errors[input.name], index === 0)
        }
      });
    }
  }

  validateInputs() {
    return validate(this.serializeForm(), this.constraints);
  }

  validateSingleInput(input, constraints) {
    return validate(input, constraints);
  }

  inputHasErros(erros, inputName) {
    return validate.contains(erros, inputName);
  }

  validateForm() {
    const errors = this.validateInputs()
    this.processErrors(errors)

    return this.isFormValid(errors)
  }

  isFormValid(errors) {
    return (errors !== undefined) ? false : true;
  }

  buildErrorIcon() {
    let icon = document.createElement("i");
    icon.className = "material-icons error-icon";
    icon.textContent = "report_problem";

    return icon;
  }

  buildErrorMessage(error) {
    let div = document.createElement("div");
    div.className = "form-control__erro-pbm";
    div.textContent = error[0];

    return div;
  }

  getFormValues(element) {
    return validate.collectFormValues(element);
  }

  serializeForm() {
    return validate.collectFormValues(this.element);
  }


}




// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/core/validation/form/form-validation.component.js